import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['term', 'termError', 'privacy', 'privacyError', 'consent', 'consentError', 'age', 'ageError'];

  post(event) {
    this.validateChecked(this.termTarget, this.termErrorTarget, event);
    this.validateChecked(this.privacyTarget, this.privacyErrorTarget, event);
    this.validateChecked(this.consentTarget, this.consentErrorTarget, event);
    this.validateChecked(this.ageTarget, this.ageErrorTarget, event);
  }

  validateChecked(target, error, event) {
    if (!target.checked) {
      error.classList.remove('hidden');
      event.preventDefault();
      return;
    }
    error.classList.contains('hidden') || error.classList.add('hidden');
  }
}
